import React, {
    Component,useState
} from 'react';
import Menu1 from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Select } from 'antd';
import { DatePicker, TimePicker, Space } from 'antd'
import { useNavigate } from 'react-router-dom';
const { Option } = Select;
const { RangePicker } = DatePicker;

// class PMPSchedule extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             title:"Preventive Maintenance Planner Schedule",
//             IsEdit: localStorage.getItem("PMPEdit"),
//             MainCategories: [
//                 {
//                     Label: "Electrical",
//                     Value: "MC001"
//                 },
//                 {
//                     Label: "Electronic Appliance",
//                     Value: "MC002"
//                 },
//                 {
//                     Label: "Stabiliser",
//                     Value: "MC003"
//                 },
//                 {
//                     Label: "DG",
//                     Value: "MC004"
//                 },
//                 {
//                     Label: "Fire Fight System",
//                     Value: "MC005"
//                 },
//                 {
//                     Label: "Fire Alarm System",
//                     Value: "MC006"
//                 },
//                 {
//                     Label: "UPS System",
//                     Value: "MC007"
//                 },
//                 {
//                     Label: "Burglar Alarm System",
//                     Value: "MC008"
//                 },
//                 {
//                     Label: "PA System",
//                     Value: "MC009"
//                 },
//                 {
//                     Label: "Chiller AC System",
//                     Value: "MC010"
//                 },
//                 {
//                     Label: "VRV AC System",
//                     Value: "MC011"
//                 },
//                 {
//                     Label: "HVLS Fans",
//                     Value: "MC012"
//                 },
//                 {
//                     Label: "STP",
//                     Value: "MC013"
//                 },
//                 {
//                     Label: "Lift",
//                     Value: "MC014"
//                 },
//                 {
//                     Label: "Escalator",
//                     Value: "MC015"
//                 },
//                 {
//                     Label: "CCTV",
//                     Value: "MC016"
//                 },
//                 {
//                     Label: "Solar",
//                     Value: "MC017"
//                 },
//                 {
//                     Label: "Door & Shutter",
//                     Value: "MC018"
//                 },
//                 {
//                     Label: "Roof",
//                     Value: "MC019"
//                 },
//                 {
//                     Label: "Domestic Water",
//                     Value: "MC020"
//                 },
//                 {
//                     Label: "Dock Leveler",
//                     Value: "MC021"
//                 },
//                 {
//                     Label: "Convyer Belt",
//                     Value: "MC022"
//                 },
//                 {
//                     Label: "MHE",
//                     Value: "MC023"
//                 },
//             ],
//             SubCategories: [
//                 {
//                     Label: "Transformer",
//                     Value: "SC001"
//                 },
//                 {
//                     Label: "RMU",
//                     Value: "SC002"
//                 },
//                 {
//                     Label: "UPS1",
//                     Value: "SC003"
//                 },
//                 {
//                     Label: "UPS2",
//                     Value: "SC004"
//                 },
//                 {
//                     Label: "Power Generator",
//                     Value: "SC005"
//                 },
//                 {
//                     Label: "Stabilizer",
//                     Value: "SC006"
//                 },
//                 {
//                     Label: "Fire Alarm System",
//                     Value: "SC007"
//                 },
//                 {
//                     Label: "Burglar Alarm System",
//                     Value: "SC08"
//                 },
//                 {
//                     Label: "PA System",
//                     Value: "SC009"
//                 },
//                 {
//                     Label: "Fire Extinguishers",
//                     Value: "SC010"
//                 },
//                 {
//                     Label: "Fire Hose reels",
//                     Value: "SC011"
//                 },
//                 {
//                     Label: "Fire Hydrant",
//                     Value: "SC012"
//                 },
//                 {
//                     Label: "Light fittings",
//                     Value: "SC013"
//                 }
//             ]
//         }
//     }
//     _doNavToPMPList = () => {
//         this.props.navigate("/PMPList");
//     }
//     _doNavToPMPReschedule = () => {
//         this.props.navigate("/PMPReschedule");
//     }
//     render() {
//         return (
//             <div className="wrapper">
//                 <Header title={this.state.title} />
//                 <Menu1 />
//                 <div className='content-wrapper'>
//                     <section className='content top-space'>
//                         <div className="m-panel">
//                             <div className="m-panel__body">
//                                 <div className="row">
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>PM type*</label>
//                                             <Select className="form-control"
//                                                 showSearch
//                                                 onChange={this._doSelectVender}
//                                                 placeholder="-- Please Select --"
//                                                 optionFilterProp="children"
//                                                 filterOption={(input, option) =>
//                                                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                                 }
//                                             >
//                                                 <Option value='1'>Bi-Weekly</Option>
//                                                 <Option value='2'>Monthly</Option>
//                                                 <Option value='3'>Quaterly</Option>
//                                                 <Option value='4'>Yearly</Option>
//                                                 <Option value='5'>One Time</Option>
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Contract*</label>
//                                             <Select className="form-control"
//                                                 showSearch
//                                                 onChange={this._doSelectVender}
//                                                 placeholder="-- Please Select --"
//                                                 optionFilterProp="children"
//                                                 filterOption={(input, option) =>
//                                                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                                 }
//                                             >
//                                                 <Option value='1'>Contract 1</Option>
//                                                 <Option value='2'>Contract 2</Option>
//                                                 <Option value='3'>Contract 3</Option>
//                                                 <Option value='4'>Contract 4</Option>
//                                                 <Option value='5'>Contract 5</Option>
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Main category*</label>
//                                             <Select className="form-control multiselect" mode="multiple"
//                                                 showSearch
//                                                 onChange={this._doSelectVender}
//                                                 placeholder="-- Please Select --"
//                                                 optionFilterProp="children"
//                                                 filterOption={(input, option) =>
//                                                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                                 }
//                                             > {
//                                                     this.state.MainCategories.map((item =>
//                                                         <Option value={item.Value}>{item.Label}</Option>
//                                                     ))
//                                                 }
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Sub category*</label>
//                                             <Select className="form-control multiselect" mode="multiple"
//                                                 showSearch
//                                                 onChange={this._doSelectVender}
//                                                 placeholder="-- Please Select --"
//                                                 optionFilterProp="children"
//                                                 filterOption={(input, option) =>
//                                                     option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                                                 }
//                                             > {
//                                                     this.state.SubCategories.map((item =>
//                                                         <Option value={item.Value}>{item.Label}</Option>
//                                                     ))
//                                                 }
//                                             </Select>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Select date*</label>
//                                             <DatePicker className="form-control" />
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Select time*</label>
//                                             <TimePicker format="HH:mm" />
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4">
//                                         <div className="form-group">
//                                             <label htmlFor='exampleInput'>Add comment*</label>
//                                             <input type="text" className="form-control" />
//                                         </div>
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="row">
//                             <div className="col-md-12 text-right">
//                                 <div className="m-page__button top-space">
//                                     <button type='button' onClick={this._doNavToPMPList} className='btn muted-button  deca-btn-orange'>Back</button>
//                                     {
//                                         this.state.IsEdit === "Edit" ?
//                                             <button type='button' className='btn muted-button  deca-btn-orange'>Cancel PMP</button>
//                                             : ""
//                                     }

//                                     <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
//                                     {
//                                         this.state.IsEdit === "Edit" ?
//                                             <button type='button' onClick={this._doNavToPMPReschedule} className='btn btn-secondary deca-btn-yellow'>Re Schedule</button>
//                                             : ""
//                                     }

//                                 </div>
//                             </div>
//                         </div>
//                     </section>
//                 </div>
//                 <Footer />
//             </div>
//         )
//     }
// }

// export default PMPSchedule;

const MainCategories = [
    {
        Label: "Electrical",
        Value: "MC001"
    },
    {
        Label: "Electronic Appliance",
        Value: "MC002"
    },
    {
        Label: "Stabiliser",
        Value: "MC003"
    },
    {
        Label: "DG",
        Value: "MC004"
    },
    {
        Label: "Fire Fight System",
        Value: "MC005"
    },
    {
        Label: "Fire Alarm System",
        Value: "MC006"
    },
    {
        Label: "UPS System",
        Value: "MC007"
    },
    {
        Label: "Burglar Alarm System",
        Value: "MC008"
    },
    {
        Label: "PA System",
        Value: "MC009"
    },
    {
        Label: "Chiller AC System",
        Value: "MC010"
    },
    {
        Label: "VRV AC System",
        Value: "MC011"
    },
    {
        Label: "HVLS Fans",
        Value: "MC012"
    },
    {
        Label: "STP",
        Value: "MC013"
    },
    {
        Label: "Lift",
        Value: "MC014"
    },
    {
        Label: "Escalator",
        Value: "MC015"
    },
    {
        Label: "CCTV",
        Value: "MC016"
    },
    {
        Label: "Solar",
        Value: "MC017"
    },
    {
        Label: "Door & Shutter",
        Value: "MC018"
    },
    {
        Label: "Roof",
        Value: "MC019"
    },
    {
        Label: "Domestic Water",
        Value: "MC020"
    },
    {
        Label: "Dock Leveler",
        Value: "MC021"
    },
    {
        Label: "Convyer Belt",
        Value: "MC022"
    },
    {
        Label: "MHE",
        Value: "MC023"
    },
],
SubCategories= [
    {
        Label: "Transformer",
        Value: "SC001"
    },
    {
        Label: "RMU",
        Value: "SC002"
    },
    {
        Label: "UPS1",
        Value: "SC003"
    },
    {
        Label: "UPS2",
        Value: "SC004"
    },
    {
        Label: "Power Generator",
        Value: "SC005"
    },
    {
        Label: "Stabilizer",
        Value: "SC006"
    },
    {
        Label: "Fire Alarm System",
        Value: "SC007"
    },
    {
        Label: "Burglar Alarm System",
        Value: "SC08"
    },
    {
        Label: "PA System",
        Value: "SC009"
    },
    {
        Label: "Fire Extinguishers",
        Value: "SC010"
    },
    {
        Label: "Fire Hose reels",
        Value: "SC011"
    },
    {
        Label: "Fire Hydrant",
        Value: "SC012"
    },
    {
        Label: "Light fittings",
        Value: "SC013"
    }
]
function PMPSchedule() {
    const title = "Preventive Maintenance Planner Schedule"
    const IsEdit = localStorage.getItem("PMPEdit")
    const navigate = useNavigate()
    const [mainCategories, setMainCategories] = useState(MainCategories)
    const [subCategories, setSubCategories] = useState(SubCategories)

    const _doNavToPMPList = () => {
        navigate("/PMPList");
    }
    const _doNavToPMPReschedule = () => {
        navigate("/PMPReschedule");
    }
    const _doSelectVender = () =>{
        
    }
    return (
        <div className="wrapper">
                <Header title={title} />
                <Menu1 />
                <div className='content-wrapper'>
                    <section className='content top-space'>
                        <div className="m-panel">
                            <div className="m-panel__body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>PM type*</label>
                                            <Select className="form-control"
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value='1'>Bi-Weekly</Option>
                                                <Option value='2'>Monthly</Option>
                                                <Option value='3'>Quaterly</Option>
                                                <Option value='4'>Yearly</Option>
                                                <Option value='5'>One Time</Option>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Contract*</label>
                                            <Select className="form-control"
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            >
                                                <Option value='1'>Contract 1</Option>
                                                <Option value='2'>Contract 2</Option>
                                                <Option value='3'>Contract 3</Option>
                                                <Option value='4'>Contract 4</Option>
                                                <Option value='5'>Contract 5</Option>
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group select_h150">
                                            <label htmlFor='exampleInput'>Main category*</label>
                                            <Select className="form-control multiselect" mode="multiple"
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > {
                                                    mainCategories.map((item =>
                                                        <Option value={item.Value}>{item.Label}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group select_h150">
                                            <label htmlFor='exampleInput'>Sub category*</label>
                                            <Select className="form-control multiselect" mode="multiple"
                                                showSearch
                                                onChange={_doSelectVender}
                                                placeholder="-- Please Select --"
                                                optionFilterProp="children"
                                                filterOption={(input, option) =>
                                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                }
                                            > {
                                                    subCategories.map((item =>
                                                        <Option value={item.Value}>{item.Label}</Option>
                                                    ))
                                                }
                                            </Select>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select date*</label>
                                            <DatePicker className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Select time*</label>
                                            <TimePicker format="HH:mm" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Add comment*</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 text-right">
                                <div className="m-page__button top-space">
                                    <button type='button' onClick={_doNavToPMPList} className='btn muted-button  deca-btn-orange'>Back</button>
                                    {
                                        IsEdit === "Edit" ?
                                            <button type='button' className='btn muted-button  deca-btn-orange'>Cancel PMP</button>
                                            : ""
                                    }

                                    <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                    {
                                        IsEdit === "Edit" ?
                                            <button type='button' onClick={_doNavToPMPReschedule} className='btn btn-secondary deca-btn-yellow'>Re Schedule</button>
                                            : ""
                                    }

                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
    )
}

export default PMPSchedule
